import { useNavigate } from "react-router-dom";
import { LOGO_URL, ICON_URL } from "@/lib/api";
import { Disc, Github, ExternalLink } from "lucide-react";

export default function Footer() {
  const navigate = useNavigate();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-brand-line bg-black mt-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <img src={ICON_URL} alt="606" className="h-12 w-12 object-contain" />
              <div>
                <div className="font-heading text-xl font-bold uppercase tracking-tight">
                  606 Community
                </div>
                <div className="overline">DISCORD GAMING HQ</div>
              </div>
            </div>
            <p className="text-sm text-zinc-400 max-w-md leading-relaxed">
              The tactical command center for our Discord gaming squad. Music,
              moderation, and a multilingual AI sidekick — all in one bot.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-4">Sitemap</div>
            <ul className="space-y-2 text-sm">
              <li><a href="#features" className="text-zinc-300 hover:text-brand-orange transition-colors" data-testid="footer-link-features">Features</a></li>
              <li><a href="#stats" className="text-zinc-300 hover:text-brand-orange transition-colors" data-testid="footer-link-stats">Stats</a></li>
              <li><a href="#join" className="text-zinc-300 hover:text-brand-orange transition-colors" data-testid="footer-link-join">Join</a></li>
              <li><button onClick={() => navigate("/dashboard")} className="text-zinc-300 hover:text-brand-orange transition-colors" data-testid="footer-link-dashboard">Dashboard</button></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline mb-4">Connect</div>
            <div className="flex flex-wrap gap-3">
              <a
                href="#"
                className="tactical-card px-4 py-3 flex items-center gap-2 text-sm font-heading uppercase tracking-wider"
                data-testid="footer-discord-link"
              >
                <Disc className="w-4 h-4 text-brand-orange" />
                Discord
              </a>
              <a
                href="#"
                className="tactical-card px-4 py-3 flex items-center gap-2 text-sm font-heading uppercase tracking-wider"
                data-testid="footer-github-link"
              >
                <Github className="w-4 h-4 text-brand-orange" />
                GitHub
              </a>
              <a
                href="#"
                className="tactical-card px-4 py-3 flex items-center gap-2 text-sm font-heading uppercase tracking-wider"
                data-testid="footer-twitter-link"
              >
                <ExternalLink className="w-4 h-4 text-brand-orange" />
                Twitter
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-brand-line flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="font-mono-tabular text-xs text-zinc-500">
            © 2026 606 COMMUNITY · ALL SYSTEMS NOMINAL
          </div>
          <div className="font-mono-tabular text-xs text-zinc-500">
            BUILD v1.0.0 · UPTIME 142d 06:24:18
          </div>
        </div>
      </div>
    </footer>
  );
}
